import { useTranslation } from 'react-i18next'
import { Box } from '@chakra-ui/react'

import { StyledLinkButton } from 'components/ui/Buttons/Button/styles'

export const NotLoggedInAvatar = (): JSX.Element => {
  const { t } = useTranslation(['auth'])

  return (
    <Box width="100px" position="relative">
      <StyledLinkButton href="/account" height="40px" isDisabled={false} className={'gtm-login-btn-header'}>
        {t('auth:login')}
      </StyledLinkButton>
    </Box>
  )
}
